import { CompanyToBeEdited } from 'pages/dashboard';
import { GridColDef } from '@mui/x-data-grid-premium';
import { FormattedMessage, useIntl } from 'react-intl';
import { ZebraDataGrid, CustomToolbar } from 'components';
import { renderDataGridLocaleText, renderFormattedDate } from 'utils';
import { Dialog, DialogContent, DialogTitle, useTheme } from '@mui/material';

type ShowCompaniesProps = {
  open: boolean;
  handleClose: () => void;
  clickedCompanies: CompanyToBeEdited[];
};

const ShowCompanies = ({ open, clickedCompanies, handleClose }: ShowCompaniesProps) => {
  const intl = useIntl();
  const theme = useTheme();

  const columns: GridColDef[] = [
    {
      field: 'order',
      headerName: intl.formatMessage({ id: 'project.table.order', defaultMessage: 'Sıra No' }),
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },
    {
      field: 'code',
      headerName: intl.formatMessage({ id: 'project.table.code', defaultMessage: 'Şirket Kodu' }),
      minWidth: 200,
    },
    {
      field: 'vkn',
      headerName: intl.formatMessage({ id: 'project.table.vkn', defaultMessage: 'Vkn' }),
      minWidth: 200,
    },
    {
      field: 'title',
      headerName: intl.formatMessage({ id: 'project.table.title', defaultMessage: 'Ünvan' }),
      minWidth: 200,
    },
    {
      field: 'dateOfAnnulment',
      headerName: intl.formatMessage({ id: 'project.table.dateOfAnnulment', defaultMessage: 'Fesih Tarihi' }),
      valueFormatter: (value) => renderFormattedDate(value),
    },
  ];

  return (
    <Dialog maxWidth="xl" open={open} onClose={handleClose}>
      <DialogTitle>
        <FormattedMessage id="report.companies" defaultMessage="Şirketler" />
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        <ZebraDataGrid
          rows={clickedCompanies}
          columns={columns}
          localeText={renderDataGridLocaleText()}
          slots={{ toolbar: () => CustomToolbar({ exportPremiumExcel: true }) }}
          hideFooter
          disableRowSelectionOnClick
          getRowId={() => crypto.randomUUID()}
          sx={{ border: `1px ${theme.palette.mode === 'dark' ? '#222833' : '#e6e8ed'} solid` }}
          disableAggregation
          disableRowGrouping
        />
      </DialogContent>
    </Dialog>
  );
};

export default ShowCompanies;
